import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkInput, getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import eye from "../../images/eye.svg";
import { NOT_EQUAL_PASSWORDS, TypeConfirm, TEXT_CHANGE_PASSWORD, TITLE_CONFIRM } from "../../utils/constants";
import { getSetPasswordForm, getRoutes } from "../../services/selectors";
import {
  SET_PASSWORD_EDIT_CP, SET_PASSWORD_EDIT_NP, SET_PASSWORD_EDIT_RNP
} from "../../services/actions/set_password_actions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { SET_PORTAL_CONFIRM } from "../../services/actions/portal_actions";


const SetPassword = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [statusCurrPassword, setStatusCurrPassword] = useState({});
  const [statusNewPassword, setStatusNewPassword] = useState({});
  const [statusReNewPassword, setStatusReNewPassword] = useState({});
  const [equalPasswords, setEqualPasswords] = useState(true);

  const [formValid, setFormValid] = useState(false);

  const refToCPInput = useRef(null);
  const refToNPInput = useRef(null);
  const refToRNPInput = useRef(null);

  const {
    current_password, new_password, re_new_password
  } = useSelector(getSetPasswordForm);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  const routes = useSelector(getRoutes);
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  const changeCurrPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusCurrPassword({ ...statusCurrPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_PASSWORD_EDIT_CP, current_password: e.target.value });
  }
  const changeNewPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusNewPassword({ ...statusNewPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_PASSWORD_EDIT_NP, new_password: e.target.value });
  }
  const changeReNewPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusReNewPassword({ ...statusReNewPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_PASSWORD_EDIT_RNP, re_new_password: e.target.value });
  }
  const changeVisibilityCP = () => {
    refToCPInput.current.type === 'password' ?
      refToCPInput.current.type = 'string' :
      refToCPInput.current.type = 'password';
  }
  const changeVisibilityNP = () => {
    refToNPInput.current.type === 'password' ?
      refToNPInput.current.type = 'string' :
      refToNPInput.current.type = 'password';
  }
  const changeVisibilityRNP = () => {
    refToRNPInput.current.type === 'password' ?
      refToRNPInput.current.type = 'string' :
      refToRNPInput.current.type = 'password';
  }

  useEffect(() => {
    setEqualPasswords(new_password === re_new_password);
    const validCurrPassword = checkInput(current_password, 8, 64, 'password').valid;
    const validNewPassword = checkInput(new_password, 8, 64, 'password').valid;
    const validReNewPassword = checkInput(re_new_password, 8, 64, 'password').valid;
    setFormValid(
      validCurrPassword && validNewPassword &&
      validReNewPassword && equalPasswords
    );
  }, [current_password, new_password, re_new_password, equalPasswords]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      current_password, new_password, re_new_password
    }
    dispatch({
      type: SET_PORTAL_CONFIRM,
      title: TITLE_CONFIRM,
      text: TEXT_CHANGE_PASSWORD,
      typeConfirm: TypeConfirm.ChangePassword,
      data
    });
  }


  return (
    <>
      <form onSubmit={handleSubmit} className="form" noValidate>

        <label htmlFor="current_password" className="label_text">
          Существующий пароль <span style={{ color: 'red' }}>*</span>
          <input
            type="password"
            id="current_password" name="current_password"
            required={true}
            value={current_password || ''}
            onChange={changeCurrPassword}
            className="input input__password"
            ref={refToCPInput}
          />
          <img src={eye} className="eye"
            alt='visibility current password' onClick={changeVisibilityCP}
          />
          <p className="error">{statusCurrPassword?.text}</p>
        </label>

        <label htmlFor="new_password" className="label_text">
          Новый пароль <span style={{ color: 'red' }}>*</span>
          <input
            type="password"
            id="new_password" name="new_password"
            required={true}
            value={new_password || ''}
            onChange={changeNewPassword}
            className="input input__password"
            ref={refToNPInput}
          />
          <img src={eye} className="eye"
            alt='visibility new password' onClick={changeVisibilityNP}
          />
          <p className="error">{statusNewPassword?.text}</p>
        </label>

        <label htmlFor="re_new_password" className="label_text">
          Новый пароль (ещё раз) <span style={{ color: 'red' }}>*</span>
          <input
            type="password"
            id="re_new_password" name="re_new_password"
            required={true}
            value={re_new_password || ''}
            onChange={changeReNewPassword}
            className="input input__password"
            ref={refToRNPInput}
          />
          <img src={eye} className="eye"
            alt='visibility re new password' onClick={changeVisibilityRNP}
          />
          <p className="error">
            {statusReNewPassword?.text}
            {!equalPasswords && NOT_EQUAL_PASSWORDS}
          </p>
        </label>
        <button type="submit"
          className={`button ${!formValid ? 'button_disabled' : ''}`}
          disabled={!formValid}
        >
          Сменить пароль
        </button>
      </form>
    </>
  );
};

export default SetPassword;
